import * as React from "react";
import { SVGProps } from "react";
const SvgContract = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20.585 2a1 1 0 0 1 1 1v5.062l2.634-4.561a.997.997 0 0 1 1.262-.419l.104.053 4.33 2.5a1.002 1.002 0 0 1 .424 1.247l-.058.119-8.696 15.06V29a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h18Zm-1 2h-16v24h16v-3.738l-3.366 1.79c-.11.058-.228.095-.348.11l-.12.007c-.131 0-.26-.026-.382-.076l-.119-.058-.107-.071a1.001 1.001 0 0 1-.38-.633l-.013-.127L14.603 21H5.585v-2h9.685l1.155-2H5.585v-2h11.994l2.006-3.474V4Zm-11 19v2h-3v-2h3ZM23.451 8.83l-6.5 11.259 2.598 1.5 6.5-11.258-2.598-1.5V8.83ZM15.585 11v2h-10v-2h10Zm2-4v2h-12V7h12Zm7.866-1.633-1 1.73 2.598 1.5 1-1.73-2.598-1.5Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgContract;
